module.exports = __webpack_public_path__ + "static/img/img-wmdcp.37de5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-wmdcp.png
// module id = 456
// module chunks = 2